module.exports = __webpack_public_path__ + "img/mh.aa0f484f.svg";